export default "__VITE_ASSET__aebf429e__"